import addFoisFromFlis from "../../functions/addFoisFromFlisAPI";

const addFoisFromFlisInTargetResources = async (targetResources, apiToken) => {
    let response = await addFoisFromFlis(apiToken, targetResources);
    if (response?.success && response.foilist?.length && response.flitofoi) {
        for (let resource of targetResources) {
            if (!resource?.id && resource?.fli && response.flitofoi[resource.fli]) {
                resource.id = response.flitofoi[resource.fli];
            }
        }
    }
};

export default addFoisFromFlisInTargetResources;